import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/11_white_large-4/11_white_large-4"
 * Contains 4 texture(s)
 */
export class CardsFront11WhiteLarge4Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/11_white_large-4/11_white_large-4';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '10-spades.png',
        '10-hearts.png',
        '10-diamonds.png',
        '10-clubs.png'
    ] as const;
}
